import Vue from 'vue';

/**
 * Global event bus for communicating between components.
 * https://alligator.io/vuejs/global-event-bus/
 */
Vue.prototype.$eventBus = new Vue();

/**
 * Event type constants, used to ensure events don't conflict Eg: `this.$events.openConfirmationModal`.
 */
Vue.prototype.$events = {
    openConfirmationModal: 'openConfirmationModal',
    openEditPricingModeModal: 'openEditPricingModeModal',
    openRenameModal: 'openRenameModal',
    openAddCostModal: 'openAddCostModal',
    openAddGroupModal: 'openAddGroupModal',
    openAddPackageModal: 'openAddPackageModal',
    openServiceChargeModal: 'openServiceChargeModal',
    openEditCostModal: 'openEditCostModal',
    openAddCurrencyModal: 'openAddCurrencyModal',
    openEditCurrencyModal: 'openEditCurrencyModal',
    openCreateAccountModal: 'openCreateAccountModal',
    createAccountModalSuccess: 'createAccountModalSuccess',
    openAddContingencyModal: 'openAddContingencyModal',
    openEditContingencyModal: 'openEditContingencyModal',
    openAddTabModal: 'openAddTabModal',
    openDuplicateTabModal: 'openDuplicateTabModal',
    openDeleteTabModal: 'openDeleteTabModal',
    openEditTabModal: 'openEditTabModal',
    openCostResourcePickerModal: 'openCostResourcePickerModal',
    openAddToTabModal: 'openAddToTabModal',
    openAddToGroupModal: 'openAddToGroupModal',
    openChangeCommissionModal: 'openChangeCommissionModal',
    openChangeMultipleModal: 'openChangeMultipleModal',
    openChangeQuantityModal: 'openChangeQuantityModal',
    openChangeTaxRateModal: 'openChangeTaxRateModal',
    openChangeDiscountModal: 'openChangeDiscountModal',
    openChangeManagementFeeModal: 'openChangeManagementFeeModal',
    openChangeStatusModal: 'openChangeStatusModal',
    openChangeUserModal: 'openChangeUserModal',
    openChangeSupplierModal: 'openChangeSupplierModal',
    openExportSummaryPdfModal: 'openExportSummaryPdfModal',
    openChangeUnitCostModal: 'openChangeUnitCostModal',
    openChangeUnitPriceModal: 'openChangeUnitPriceModal',
    openImportModal: 'openImportModal',
    openColumnSettingsModel: 'openColumnSettingsModel',
    openStatusMessageModal: 'openStatusMessageModal',
};
